var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.48,22.58v1h0Zm95.79-2.08H104.5l-.23,47.33a2.5,2.5,0,0,1-2.5,2.49L48,70.4V222.77A12.74,12.74,0,0,0,60.73,235.5H195.27A12.74,12.74,0,0,0,208,222.77V33.23A12.74,12.74,0,0,0,195.27,20.5ZM149.58,44.84a12,12,0,1,1,24.06,0v3.63a12,12,0,1,1-24.06,0Zm22.21,149H84.21a2.5,2.5,0,1,1,0-5h87.58a2.5,2.5,0,0,1,0,5Zm0-32.29H84.21a2.5,2.5,0,1,1,0-5h87.58a2.5,2.5,0,1,1,0,5Zm0-32.29H84.21a2.5,2.5,0,0,1,0-5h87.58a2.5,2.5,0,0,1,0,5Zm13.06-39a2.38,2.38,0,0,1-2.38,2.38H140.75a2.38,2.38,0,0,1-2.38-2.38V76.78c0-8,5.36-12.58,14.71-12.58a2.36,2.36,0,0,1,1.76.78l6.71,7.38L167.71,65a2.41,2.41,0,0,1,1.82-.84c9.59,0,15.32,4.7,15.32,12.58ZM99.48,23.57,52.12,65.39l47.16-.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9b1838b12adbccf1d298ca31d4298d98.svg";
export { ForwardRef as ReactComponent };